import { COOKIE_NAME_CONSENT_STATUS, getCookieValue } from 'dibs-consented-storage';

/** OneTrust categories required for Elevar: Performance + Targeting. */
const ELEVAR_REQUIRED_CONSENT_GROUPS = ['C0002', 'C0004'] as const;

const parseConsentGroups = (groupsParam: string): Record<string, boolean> =>
    Object.fromEntries(
        groupsParam.split(',').map(entry => {
            const [key, value] = entry.split(':');
            return [key, value === '1'];
        })
    );

export const isElevarTrackingAllowed = (): boolean => {
    const consentStatus = getCookieValue(document.cookie, COOKIE_NAME_CONSENT_STATUS);
    const groupsParam = consentStatus ? new URLSearchParams(consentStatus).get('groups') : null;

    if (!groupsParam) {
        return false;
    }

    const groups = parseConsentGroups(groupsParam);
    return ELEVAR_REQUIRED_CONSENT_GROUPS.every(id => groups[id] === true);
};
